export function pad(n, width, z = '0') {
    n = String(n)
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
}

function convertLatLon(value, isLon) {
    return {
        dir: value < 0 ? (isLon ? 'W' : 'S') : isLon ? 'E' : 'N',
        deg: 0 | (value < 0 ? (value = -value) : value),
        min: 0 | (((value += 1e-9) % 1) * 60),
        sec: (0 | (((value * 60) % 1) * 6000)) / 100,
    }
}

export function formatLatLon(value, isLon) {
    const c = convertLatLon(value, isLon)
    return `${c.deg}° ${c.min}" ${c.sec}' ${c.dir}`
}

export function formatDate(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(date.getDate(), 2)}`
}

export function formatDatetime(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(date.getDate(), 2)} ${pad(date.getHours(), 2)}:${pad(date.getMinutes(), 2)}:${pad(date.getSeconds(), 2)}`
}

export function drawPie(canvas, context, datalist, colors) {
    const radius = canvas.height / 2 - 5
    const centerX = canvas.width / 2
    const centerY = canvas.height / 2
    const total = datalist.reduce((sum, v) => sum + v, 0)
    const offset = Math.PI / 2
    let lastEnd = 0
    datalist.forEach((value, i) => {
        context.beginPath()
        context.fillStyle = colors[i]
        context.moveTo(centerX, centerY)
        const arcSector = Math.PI * (2 * value / total)
        context.arc(centerX, centerY, radius, lastEnd - offset, lastEnd + arcSector - offset, false)
        context.lineTo(centerX, centerY)
        context.fill()
        context.closePath()
        lastEnd += arcSector
    })
}
